import CheckboxIcon from "@/Icons/Checkbox";

import { FC, useMemo } from "react";

import { twMerge } from "tailwind-merge";

export const Checkbox: FC<{
  label?: string;
  isChecked?: boolean;
  onChange?: (e: React.MouseEvent) => any;
  isDisabled?: boolean;
  isVisibleByDefault?: boolean;
}> = (props) => {
  const { label, isChecked, isDisabled, onChange } = props;

  const handleClick = (e: React.MouseEvent) =>
    !isDisabled && onChange && onChange(e);

  const checkboxView = useMemo(() => {
    if (isChecked) {
      return <CheckboxIcon className={isDisabled ? "opacity-50" : ""} />;
    }

    return (
      <div
        className={twMerge(
          "h-[18px] w-[18px] cursor-pointer border border-black",
          "group-hover:visible",
          isDisabled && "border-grey4 bg-grey2",
        )}
      />
    );
  }, [isChecked, isDisabled]);

  return (
    <>
      <div className="flex" onClick={handleClick}>
        <div className="mt-0.5 mb-1 bg-white">{checkboxView}</div>
        {label && (
          <label className="mx-2" onClick={handleClick}>
            {label}
          </label>
        )}
      </div>
    </>
  );
};
